import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static targets = ["selectList", "newListName", "dropdownTrigger"]
  static values = {
    hasLists: Boolean
  }

  connect() {
    if (this.hasListsValue) {
      this.listsListSelectize = $(this.selectListTarget).selectize()
    }
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.listsListSelectize !== undefined) {
      this.listsListSelectize[0].selectize.destroy()
    }
  }

  dismiss() {
    // Close the dropdown by clicking on the button
    // the toggle method is not working well here
    this.dropdownTriggerTarget.click()
  }

  listTypeSelection(event) {
    if (event.params.type === "new") {
      this.newListNameTarget.disabled = false
      this.newListNameTarget.required = true
      this.listsListSelectize[0].selectize.disable()
    } else if (event.params.type === "existing") {
      this.newListNameTarget.disabled = true
      this.newListNameTarget.required = false
      this.listsListSelectize[0].selectize.enable()
    }
  }

  // Get lists and update the <select> -
  // triggered when a list is created (listCreated event)
  updateListsList(event) {
    const newList = event.detail.list
    const selectize = this.listsListSelectize[0].selectize

    selectize.addOption({ value: newList.id, text: newList.name })
    selectize.refreshOptions(false)
    selectize.setValue(newList.id)
  }
}
